import React, { useState, useEffect } from "react";
import { Form, Button, Col } from "react-bootstrap";
import { withCookies } from "react-cookie";
import htmlToDraft from "html-to-draftjs";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState } from "draft-js";
import { useTranslation } from "react-i18next";
import configVars from "../../config";

const { createSliderWithTooltip } = Slider;
const SliderWT = createSliderWithTooltip(Slider);

const wrapperStyle = { width: "100%" };

const CurrentSituation = ({ selectedTask }) => {
  const [translation] = useTranslation("translations");
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [factorsEditorState, setFactorsEditorState] = useState(null);
  const [plusFactor, setPlusFactor] = useState(false);
  const [impactsEditorState, setImpactsEditorState] = useState(null);
  const priority =
    selectedTask && parseInt(selectedTask.priority)
      ? parseInt(selectedTask.priority)
      : 0;

  useEffect(() => {
    if (selectedTask) {
      setTitle({ value: selectedTask.title, error: false });

      let _plusFactor =
        selectedTask?.factor_description_type === "Plus" ? true : false;
      setPlusFactor(_plusFactor);

      let _factorDesc = null;
      if (selectedTask?.idea_bank_factor_description) {
        _factorDesc = selectedTask?.idea_bank_factor_description;
      } else if (selectedTask?.current_situation_factor_description) {
        _factorDesc = selectedTask?.current_situation_factor_description;
      } else if (selectedTask?.action_plan_factor_description) {
        _factorDesc = selectedTask?.action_plan_factor_description;
      }

      if (_factorDesc) {
        const contentBlock1 = htmlToDraft(_factorDesc);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setFactorsEditorState(editorState);
        }
      }
      let _impacts = selectedTask?.performance_impact_description;

      if (_impacts) {
        const contentBlock2 = htmlToDraft(_impacts);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setImpactsEditorState(editorState);
        }
      }
    }
  }, [selectedTask]);

  return (
    <Form>
      <div>
        <div className="d-lg-flex flex-lg-column">
          <Form.Group className="mb-3">
            <Form.Label>
              <b>{translation("task_forms.current_situation.field1.label")}</b>
            </Form.Label>
            <Form.Control
              disabled
              type="text"
              placeholder={translation(
                "task_forms.current_situation.field1.placeholder"
              )}
              value={title?.value}
              isInvalid={title?.error}
              style={{ fontSize: "14px", padding: "0.5rem 0.5rem" }}
            />
            {title?.error && (
              <Form.Control.Feedback type="invalid">
                {translation("task_forms.current_situation.field1.error")}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </div>

        <div className="d-flex justify-content-center mt-2">
          <Col className="d-flex pe-2">
            <Button
              className={
                plusFactor ? "text-sy-black rounded" : "text-white rounded"
              }
              variant={plusFactor ? "outline-sea-green" : "sea-green"}
              style={{
                width: "100%",

                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              disabled
            >
              {translation("task_forms.current_situation.factors.minus")}
            </Button>
          </Col>
          <Col className="d-flex ps-2">
            <Button
              className={
                plusFactor ? "text-white rounded" : "text-sy-black rounded"
              }
              variant={plusFactor ? "sea-green" : "outline-sea-green"}
              style={{
                width: "100%",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              disabled
            >
              {translation("task_forms.current_situation.factors.plus")}
            </Button>
          </Col>
        </div>
      </div>
      <div className="d-flex  mt-3 mb-5">
        <div style={wrapperStyle}>
          <p>
            <b> {translation("task_forms.current_situation.field2.label")} </b>
          </p>
          <div className="px-2" >
          <SliderWT
            min={0}
            max={10}
            defaultValue={priority}
            disabled
            marks={{ 0: 0, 3: 3, 5: 5, 7: 7, 10: 10 }}
            step={null}
            tipFormatter={(value) => {
              switch (value) {
                case 0:
                  return (
                    <div style={{ width: "70px" }}>
                      {translation("task_forms.current_situation.field2.0")}
                    </div>
                  );
                case 3:
                  return (
                    <div style={{ width: "70px" }}>
                      {translation("task_forms.current_situation.field2.1")}
                    </div>
                  );
                case 5:
                  return (
                    <div style={{ width: "70px" }}>
                      {translation("task_forms.current_situation.field2.2")}
                    </div>
                  );

                case 7:
                  return (
                    <div style={{ width: "70px" }}>
                      {translation("task_forms.current_situation.field2.3")}
                    </div>
                  );
                case 10:
                  return (
                    <div style={{ width: "70px" }}>
                      {translation("task_forms.current_situation.field2.4")}
                    </div>
                  );
                default:
                  return "";
              }
            }}
          />
          </div>
        </div>
      </div>
      <div>
        <Form.Group className="mb-3">
          <Form.Label>
            {" "}
            <b>
              {" "}
              {plusFactor
                ? translation("task_forms.current_situation.field3.label_plus")
                : translation(
                    "task_forms.current_situation.field3.label_minus"
                  )}
            </b>
          </Form.Label>

          <Editor
            disabled={true}
            toolbar={configVars?.wysiwygToolbarOptions}
            editorState={factorsEditorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editor-wrapper"
          />
        </Form.Group>
      </div>

      <Form.Group className="mb-3 " style={{ marginTop: "20px" }}>
        <Form.Label>
          <b>{translation("task_forms.current_situation.field4.label")}</b>
        </Form.Label>

        <Editor
          disabled={true}
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={impactsEditorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
        />
      </Form.Group>
    </Form>
  );
};

export default withCookies(CurrentSituation);
